module.exports = __webpack_public_path__ + "static/img/activity2.479fc87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/activity2.jpg
// module id = 8THk
// module chunks = 0